import { PropsWithChildren, CSSProperties } from 'react';
import { Rnd } from 'react-rnd';

import { TWindowCoords, TWindowMoveDelta, TWindowResizeDirection, TWindowSize } from './types';

interface DraggableWrapperProps extends PropsWithChildren {
  className?: string;
  handlerClassName: string;
  size: TWindowSize;
  coords: TWindowCoords;
  onDragStop(coords: TWindowCoords): void;
  // Отдаём наверх направление, а не пятый аргумент react-rnd: тот содержит
  // offsetFromParent и живёт не в той системе координат, что проп position.
  // Новые координаты считает getCoordsAfterResize.
  onResizeStop(delta: TWindowMoveDelta, direction: TWindowResizeDirection): void;
  style?: CSSProperties;
}

export function DraggableWrapper({
  className,
  handlerClassName,
  size,
  coords,
  onDragStop,
  onResizeStop,
  children,
  style,
}: DraggableWrapperProps) {
  return (
    <Rnd
      style={style}
      className={className}
      dragHandleClassName={handlerClassName}
      size={{ ...size }}
      position={{ ...coords }}
      minWidth="250px"
      minHeight="74px"
      onDragStop={(_event, _dragData) => {
        onDragStop({ x: _dragData.x, y: _dragData.y });
      }}
      onResizeStop={(_event, _direction, _ref, _delta) => {
        onResizeStop(_delta, _direction);
      }}
    >
      {children}
    </Rnd>
  );
}
